export default {
  path: '/accounts',
  name: 'accounts',
  component: () => import('../components/Layout'),
  redirect: { name: 'AccountList' },
  children: [
    {
      name: 'AccountList',
      path: '',
      component: () => import('../views/account/List')
    },
    {
      name: 'AccountCreate',
      path: 'create',
      component: () => import('../views/account/Create')
    },
    {
      name: 'AccountShow',
      path: ':id',
      component: () => import('../views/account/Show')
    }
  ]
}
